<template>
  <div class="product-detail">
    <div class="header">
      <button class="back-button" @click="goBack">
        <i class="fas fa-arrow-left"></i>
        返回
      </button>
    </div>

    <div class="product-images">
      <img
        :src="product.mainImage"
        alt="Product Main Image"
        class="main-image"
      />
    </div>
    <div class="product-info">
      <h1 class="product-title">{{ product.title }}</h1>
      <p class="view-count">浏览量: {{ product.viewCount }}</p>
    </div>
    <div class="product-detail-images">
      <h2>商品详情</h2>
      <div class="detail-images">
        <img
          v-for="(image, index) in product.detailImages"
          :key="index"
          :src="image.houseDetailImageUrl"
          alt="Detail Image"
        />
      </div>
    </div>
    <div class="footer-buttons">
      <button
        class="customer-service"
        title="客服"
        @click="contactCustomerService"
      >
        <i class="fas fa-headset"></i>
        <span class="buttonFont">客服</span>
      </button>
      <button class="favorite" title="收藏" @click="toggleFavorite">
        <i :class="isFavorite ? 'fas fa-heart' : 'far fa-heart'"></i>
        <!-- 根据收藏状态切换图标 -->
        <span class="buttonFont">{{ isFavorite ? "已收藏" : "收藏" }}</span>
      </button>
      <button class="shoppingCart" title="加入购物车" @click="addToCart">
        <div class="cart-with-plus">
          <i class="fas fa-shopping-cart"></i>
          <i class="fas fa-plus cart-plus"></i>
        </div>
        <!-- <span class="cartFont"></span> -->
      </button>
      <button class="view-schematic" @click="viewSchematic">
        查看施工图
      </button>

    </div>
  </div>
</template>
  
  <script>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router"; // 导入 useRoute 和 useRouter
import { getCurrentInstance } from "vue";

export default {
  setup() {
    const route = useRoute(); // 获取当前路由信息
    const houseId = route.params.houseId; // 获取传递的 id
    const pageNo = route.query.pageNo; 
    console.log("pageNo", pageNo);
    const router = useRouter(); // 获取 router 实例
    const { proxy } = getCurrentInstance();
    const cart = ref(null);

    const cartCount = ref(0);

    const product = ref({
      title: "",
      viewCount: 0,
      mainImage: "",
      detailImages: [],
      pdfUrl:""
    });

    // 状态变量，跟踪是否已收藏
    const isFavorite = ref(false);

    const viewSchematic = () => {
      location.href = product.value.pdfUrl;
    };

    const toggleFavorite = async () => {
      let status;
      if (isFavorite.value) {
        status = 0;
      } else {
        status = 1;
      }
      const url = "/house/likeHouse";
      proxy.$tools
        .request(url, { reqBody: { status: status, houseId: houseId } })
        .then((response) => {
          console.log("请求了收藏接口:" + JSON.stringify(response.data));
          isFavorite.value = response.data.rspBody.isFavorite;
        })
        .catch((error) => {
          console.error(error);
        });
      // isFavorite.value = !isFavorite.value; // 切换收藏状态
      // console.log(isFavorite.value ? '已添加到收藏' : '已移除收藏');
    };

    const contactCustomerService = () => {
      router.push("/houseCustomerService"); 
    };

    const getHouseDetail = async () => {
      const url = "/house/getHouseDetail";
      proxy.$tools
        .request(url, { reqBody: { houseId: houseId } })
        .then((response) => {
          product.value.title = response.data.rspBody.houseName;
          product.value.viewCount = response.data.rspBody.pageView;
          product.value.mainImage = response.data.rspBody.houseImageUrl;
          product.value.detailImages = response.data.rspBody.houseDetailList;
          product.value.pdfUrl = response.data.rspBody.housePdfUrl;
          isFavorite.value = response.data.rspBody.isFavorite;
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const viewHouse = async () => {
      const url = "/house/viewHouse";
      proxy.$tools
        .request(url, { reqBody: { houseId: houseId } })
        .then((response) => {
          console.log("请求浏览房子的接口" + JSON.stringify(response.data));
        })
        .catch((error) => {
          console.error(error);
        });
    };
    const addToCart = async () => {
    };

const goBack = () => {
  // 直接返回上一页（列表页）
  router.go(-1);
};

    const viewCart = () => {
      router.push("/houseCart"); // 假设您有一个购物车页面，路由名称为 'Cart'
    };

    const checkLogin = () => {
      let token = localStorage.getItem("token"); // 从缓存中获取token
        token = token || null;
      if (token) {
        // 如果有token，调用后端接口验证
        console.log("进入了检查登陆状态");
        const url = "/login/checkLoginStatus";
        proxy.$tools
          .request(url, { reqBody: {} })
          .then((response) => {
            const returnCode = response.data.rspHead.reurnCode;
            console.log("返回的code:" + JSON.stringify(response,2,null));
            if (!"000000" === returnCode) {
              router.push("/error");
            }
            const status = response.data.rspBody.status;
            if ("0" === status) {
              router.push("/appLogin");
            } 
          })
          .catch((error) => {
            // 处理错误情况
            console.error(error);
          });
      } else {
        // 如果没有token，重定向到登录页面
        router.push("/appLogin");
      }
      
      // 这里可以添加查看施工图的逻辑
    };

    onMounted(() => {
      checkLogin();
      viewHouse();
      getHouseDetail();
    });

    return {
      product,
      viewSchematic,
      toggleFavorite,
      isFavorite,
      contactCustomerService,
      goBack,
      viewCart,
      addToCart,
      cart,
      cartCount,
    };
  },
};
</script>
  
  <style scoped>
.header {
  display: flex;
  justify-content: space-between; /* 左右对齐 */
  align-items: center; /* 垂直居中 */
  padding: 10px;
  position: fixed; /* 固定定位 */
  top: 0; /* 置于页面顶部 */
  left: 0; /* 确保左侧对齐 */
  width: 100%; /* 横跨整个页面 */
  background-color: white; /* 背景色，防止内容被遮挡 */
  z-index: 1000; /* 确保头部在其他内容之上 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 可选，为头部添加阴影效果 */
}

.back-button{
  position: relative; /* 为绝对定位的子元素提供参照 */
  border: none;
  background: none;
  cursor: pointer;
  font-size: 18px;
  min-width: 80px; /* 设置按钮的最小宽度 */
}



.product-detail {
  padding: 0;
}

.product-images {
  text-align: center;
  margin: 0;
}

.main-image {
  width: 100%;
  height: auto;
}

.product-info {
  margin: 10px 0;
}

.product-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  margin: 0;
}

.view-count {
  color: gray;
  text-align: left;
}

.product-detail-images {
  margin-top: 20px;
}

.detail-images {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.detail-images img {
  width: 100%;
  height: auto;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin: 0;
  
}

.footer-buttons button {
  padding: 10px; /* 增加内边距 */
  border: none; /* 去掉边框 */
  color: white;
  margin: 0;
  cursor: pointer;
  transition: opacity 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.customer-service {
  background-color: white;
  flex: 0.8;
}

.favorite {
  background-color: white;
  flex: 1.2;
}

.shoppingCart {
  /* 添加线性渐变背景 */
  border-radius: 10px 0 0 10px;
  background-image: linear-gradient(to right, #f3e443, #ebaf24);
  flex: 2;
  border: none;
  margin: 0;
  color: #ffffff;
}

.link-wrapper {
    text-decoration: none; /* 去掉链接下划线 */
}

.view-schematic {
  border-radius: 0 10px 10px 0;
  /* 保留背景颜色 */
  /* background-color: #dbc906;  */
  background-color: #ef7d4f;
  flex: 6;
  border: none;
  margin: 0;
  /* border-radius: 100px; */
  color: rgba(18, 4, 4, 0.849); /* 确保文字颜色为白色 */
  font-size: 18px;
  font-weight: 550;
  letter-spacing: 2px;
}

.footer-buttons button:hover {
  opacity: 0.9; /* 鼠标悬停时的透明度变化 */
}

.footer-buttons i {
  font-size: 20px; /* 图标大小 */
  margin-bottom: 5px; /* 图标与文字之间的间距 */
  /* 设置图标颜色 */
  color: #1a1313;
}

.buttonFont {
  color: #010a13; /* 设置图标颜色 */
}

.cartFont {
  color: #fdfdfd; /* 设置图标颜色 */
  font-size: 13px;
}

.cart-with-plus {
  position: relative;
  display: inline-block;
}

.cart-plus {
  position: absolute;
  top: -12px; /* 根据需要调整 */
  right: -11px; /* 根据需要调整 */
  size: 1px;
  font-size: 0.2em; /* 根据需要调整加号的大小 */
}
</style>